import React from 'react';

const SubscriptionPlans = () => {
  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-light-5">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-dark-1 mb-4 font-sans">
            Nos formules d'abonnement
          </h2>
          <p className="text-light-1 text-lg max-w-3xl mx-auto font-sans">
            Choisissez la formule qui correspond le mieux aux besoins de votre établissement
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Formule Individuelle */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-light-3 hover:shadow-md transition-shadow duration-300">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-1 rounded-full flex items-center justify-center text-white text-xl mr-4">
                🔹
              </div>
              <h3 className="text-xl font-bold text-dark-1 font-sans">Individuel (par élève)</h3>
            </div>
            
            <p className="text-light-1 mb-6 font-sans">
              Pour les parents d'élèves ou écoles qui veulent équiper certains enfants :
            </p>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Accès personnel à la plateforme NextMaker</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Ressources et parcours progressifs</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Kit pédagogique individuel (optionnel selon formule)</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Badge et certificat en fin de parcours</span>
              </li>
            </ul>
            
            <div className="bg-purple-3 rounded-lg p-4 mb-6">
              <p className="text-purple-1 font-medium font-sans text-sm">
                👉 Idéal pour clubs extrascolaires ou élèves passionnés
              </p>
            </div>
            
            <button className="w-full bg-red-4 hover:bg-transparent text-white hover:text-red-4 font-sans py-3 px-6
            rounded-full transition-colors duration-300 border-2 border-red-4">
              Choisir cette formule
            </button>
          </div>

          {/* Formule Écoles & Groupes */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-light-3 hover:shadow-md transition-shadow duration-300">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-purple-1 rounded-full flex items-center justify-center text-white text-xl mr-4">
                🔹
              </div>
              <h3 className="text-xl font-bold text-dark-1 font-sans">Écoles & Groupes</h3>
            </div>
            
            <p className="text-light-1 mb-6 font-sans">
              Pensé pour les classes ou établissements :
            </p>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Accès collectif (enseignants + élèves)</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Gestion centralisée des comptes par l'école</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Kits partagés ou individuels selon l'abonnement choisi</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-green-1 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-dark-1 font-sans">Suivi et reporting des progrès des élèves</span>
              </li>
            </ul>
            
            <div className="bg-purple-3 rounded-lg p-4 mb-6">
              <p className="text-purple-1 font-medium font-sans text-sm">
                👉 Idéal pour intégration dans le programme scolaire ou projets clubs
              </p>
            </div>
            
            <button className="w-full bg-red-4 hover:bg-transparent text-white hover:text-red-4 font-sans py-3 px-6
            rounded-full transition-colors duration-300 border-2 border-red-4">
              Demander un devis
            </button>
          </div>
        </div>

        {/* Note importante */}
        {/* <div className="text-center bg-red-3 rounded-2xl p-6 max-w-3xl mx-auto">
          <p className="text-red-4 font-medium font-sans">
            NB: Des tarifs préférentiels sont disponibles pour les établissements scolaires et les commandes groupées.
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default SubscriptionPlans;